const externalLinkContent = {
  title: {
    en_HK: "You are leaving this Hang Seng Bank website",
    zh_HK: "你將離開此恒生銀行網站",
    zh_CN: "你将离开此恒生银行网站",
  },
  hase_message: {
    en_HK:
      "This link may allow you to access another Hang Seng Bank Group website. Please read the terms and conditions of the linked website, which may differ from the terms and conditions of Hang Seng Bank Limited's website.",
    zh_HK:
      "閣下將透過此連結至恒生銀行集團其他網站。恒生銀行有限公司網站與該等連結網站的細則及條款可能互有差異，故請細閱該等連結網站的細則及條款。",
    zh_CN:
      "阁下将透过此连结至恒生银行集团其他网站。恒生银行有限公司网站与该等连结网站的细则及条款可能互有差异，故请细阅该等连结网站的细则及条款。",
  },
  other_message: {
    en_HK:
      "This hyperlink may allow you to leave Hang Seng Bank Limited website. The website accessed through this hyperlink may not provide you with any regulatory protections. Hang Seng Bank Limited is not liable for your use of the hyperlink website.",
    zh_HK:
      "此連結可引致閣下離開恒生銀行有限公司之網站。本網站連結之其他網站未必能給予閣下任何保障，閣下透過此連結到之其他網站的使用本行概不負責。",
    zh_CN:
      "此连结可引致阁下离开恒生银行有限公司之网站。本网站连结之其他网站未必能给予阁下任何保障，阁下透过此连结到之其他网站的使用本行概不负责。",
  },
};

var whitelist = [
  {
    group: "dit",
    domains: [
      /^https?:\/\/dit(-author)?\.hk\.hsbc(\/?|(\/.+)+)$/i,
      /^https?:\/\/(personal-cn-dit|uk-dit|static-origin-dit)\.hk\.hsbc(\/?|(\/.+)+)$/i,
    ],
  },
  {
    group: "sit",
    domains: [
      /^https:\/\/hsvm-uat\.hsbc\.com\.hk(\/?|(\/.+)+)$/i,
      /^https?:\/\/sit(-author)?\.hk\.hsbc(\/?|(\/.+)+)$/i,
      /^https?:\/\/(personal-cn-sit|uk-sit|static-origin-sit)\.hk\.hsbc(\/?|(\/.+)+)$/i,
    ],
  },
  {
    group: "uat",
    domains: [
      /^https?:\/\/uat(-author)?\.hk\.hsbc(\/?|(\/.+)+)$/i,
      /^https?:\/\/(personal-cn-uat|uk-uat|static-origin-uat)\.hk\.hsbc(\/?|(\/.+)+)$/i,
    ],
  },
  {
    group: "environments",
    domains: [
      /^https?:\/\/hkg\dvl\d{4}o\.hk\.hsbc:(5433|4502|8443|4503)(\/?|(\/.+)+)$/i,
      /^https?:\/\/hkg\dvl\d{4}\.p2g\.netd2\.hk\.hsbc:31000(\/?|(\/.+)+)$/i,
      /^https?:\/\/hkg\dvl\d{4}-\d{4}\.p2g\.netd2\.hk\.hsbc(\/?|(\/.+)+)$/i,
      /^https?:\/\/hkg\dvl\d{4}(-\d{4})?\.p2g\.hsbc\.com\.hk(\/?|(\/.+)+)$/i,
      /^https?:\/\/demo-dp\.hk\.hsbc(\/?|(\/.+)+)$/i,
      /^https?:\/\/(dit|sit|uat)\.hsbc\.com\.hk(\/?|(\/.+)+)$/i,
      /^https?:\/\/cms\.hangsenginvestment\.com(\/?|(\/.+)+)$/i,
      /^https?:\/\/www\.hangsenginvestment\.com(\/?|(\/.+)+)$/i,
    ],
  },
];

function showModal(url, target, content) {
  $(".modal.external").modal("show");
  // $('.modal.external .HSVMModal__title').text(content.title)
  // $('.modal.external .HSVMModal__text p').text(content.content)
  $(".HSVMModal__button--submit")
    .off("click")
    .on("click", function () {
      window.open(url);
      $(".modal.external").modal("hide");
    });
}

function isCurrentDomain(href) {
  var hostname = window.location.hostname;
  var hostRegex = new RegExp(
    "^https?://(?:[^@\\/\\n]+@)?(?:[^:\\/?\\n\\.]+\\.)*?" +
      hostname +
      "(:\\d+)*/"
  );
  return hostRegex.test(href);
}

function isInWhitelist(href) {
  for (var i = 0; i < whitelist.length; i++) {
    var whitelisted = whitelist[i];
    var group = whitelisted.group;
    var domains = whitelisted.domains;
    for (var j = 0; j < domains.length; j++) {
      var domain = domains[j];
      if (domain.test(href)) {
        return true;
      }
    }
  }
  return false;
}

function externalNotice() {
  (function ($) {
    $(document).ready(function () {
      $(".HSVMModal__button--Cancel").on("click", function () {
        $(".modal.external").modal("hide");
      });
      $("body").delegate("a[href]", "click", function (event) {
        var $this = $(this);
        $this.blur(); // lose focus after click
        var externalLinks = [
          {
            group: "hase",
            domains: [
              /^https?:\/\/(?:[^@\/\n]+@)?(?:[^:\/?\n\.]+\.)*hangseng\.com(\/?|(\/.+)+)$/i,
              /^haserbapp:\/\//i,
            ],
          },
        ];
        var bypassExternal = $this.attr("data-bypassExternalChecking");
        if (!bypassExternal || bypassExternal !== "true") {
          var href = $this.attr("href");
          if (!href) {
            return;
          }
          for (var i = 0; i < externalLinks.length; i++) {
            var externalLink = externalLinks[i];
            var target = $this.attr("target") || "_blank";
            var domains = externalLink.domains;
            for (var j = 0; j < domains.length; j++) {
              var domain = domains[j];
              if (domain.test(href)) {
                // prevent default if it is a link from expected groups
                event.preventDefault();
                showModal(href, target, {
                  title: externalLinkContent.title.en_HK,
                  content: externalLinkContent.hase_message.en_HK,
                });
                // _promptExternalLinkConfirmation(href, target, group);
                return;
              }
            }
          }
          // the link is not a full URL (i.e. absolute/relative path, "javascript:void(0);", "#")
          // or in the whitelist
          // or the current domain
          if (
            href.indexOf("://") < 0 ||
            isInWhitelist(href) ||
            isCurrentDomain(href)
          ) {
            return;
          }
          // other unexpected external link
          event.preventDefault();
          // _promptExternalLinkConfirmation(href, target, 'other');
          showModal(href, target, {
            title: externalLinkContent.title.en_HK,
            content: externalLinkContent.other_message.en_HK,
          });
        }
      });
    });
  })($);
}

function onShareExternalNotice(href) {
  showModal(false, "_blank", {
    title: externalLinkContent.title.en_HK,
    content: externalLinkContent.other_message.en_HK,
  });
}

export { externalNotice, onShareExternalNotice };
